import React from "react";
import { WhyUS } from "../../lib/ProjectDetails";
import PagerHero from "../PageHero/PageHero";

const WhyChooseUs = () => {
  return (
    <section className="why-us-container" aria-labelledby="why-choose-us-title">
      <PagerHero headline="Why Choose Porto Consulting?" />

      <div className="inner-container">
        <ul className="reasons-list">
          {WhyUS.map((data) => {
            return (
              <li key={data.id} className="list-item">
                <span className="number" aria-hidden="true">
                  {data.id}
                </span>
                <span className="reason-text">{data.reason}</span>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default WhyChooseUs;
